export default __webpack_public_path__ + "static/media/famoushookah.eda9640a.mp4";